import { render, staticRenderFns } from "./TaskCommon.vue?vue&type=template&id=65d32d23&scoped=true"
import script from "./TaskCommon.vue?vue&type=script&lang=js"
export * from "./TaskCommon.vue?vue&type=script&lang=js"
import style0 from "./TaskCommon.vue?vue&type=style&index=0&id=65d32d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d32d23",
  null
  
)

export default component.exports